// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1g--V","content":"styles_content__1kAe5","selectAll":"styles_selectAll__15Cb1"};